import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { stoweConfig } from "./data";

export default function StowePage() {
  return <CityPageTemplate config={stoweConfig} />;
}